<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <card :title="$t('userGroups.title')" :on-add-object="openCreate">
          <div v-if="!loaded" class="text-center text-secondary py-4">{{ $t('common.loading') }}</div>
          <div v-else-if="groups.length === 0" class="text-center text-secondary py-4">
            {{ $t('userGroups.noGroups') }}
          </div>
          <el-table v-else :data="groups" row-key="id" style="width:100%">
            <el-table-column :label="$t('userGroups.name')" prop="name" min-width="160" />
            <el-table-column :label="$t('userGroups.identificationNumber')" prop="identificationNumber" min-width="160" />
            <el-table-column :label="$t('userGroups.members')" width="110">
              <template #default="scope">{{ scope.row.userCount }}</template>
            </el-table-column>
            <el-table-column label="" width="140" align="right">
              <template #default="scope">
                <el-button size="small" @click="openEdit(scope.row)">
                  <i class="material-icons" style="font-size:1rem">edit</i>
                </el-button>
                <el-button size="small" type="danger" @click="confirmDelete(scope.row)">
                  <i class="material-icons" style="font-size:1rem">delete</i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>
    </div>

    <!-- Create / edit dialog -->
    <el-dialog v-model="showForm" :title="editMode ? $t('userGroups.editGroup') : $t('userGroups.newGroup')" width="480">
      <div class="mb-3">
        <label class="form-label">{{ $t('userGroups.name') }} <span class="text-danger">*</span></label>
        <el-input v-model="form.name" maxlength="100" />
      </div>
      <div class="mb-3">
        <label class="form-label">{{ $t('userGroups.identificationNumber') }}</label>
        <el-input v-model="form.identificationNumber" maxlength="100" />
      </div>
      <template #footer>
        <el-button @click="showForm = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm">{{ $t('common.submit') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../services/api';
import Card from '../../components/Card.vue';
import { ElDialog, ElInput, ElButton, ElTable, ElTableColumn, ElMessageBox } from 'element-plus';

export default {
  name: 'ManageUserGroups',
  components: {
    Card,
    ElDialog, ElInput, ElButton, ElTable, ElTableColumn,
  },
  data() {
    return {
      loaded: false,
      groups: [],
      showForm: false,
      saving: false,
      editMode: false,
      form: { id: null, name: '', identificationNumber: '' },
    };
  },
  created() {
    this.fetchGroups();
  },
  methods: {
    async fetchGroups() {
      this.loaded = false;
      try {
        const res = await api.get('/UserGroup');
        this.groups = res.data;
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      } finally {
        this.loaded = true;
      }
    },
    openCreate() {
      this.editMode = false;
      this.form = { id: null, name: '', identificationNumber: '' };
      this.showForm = true;
    },
    openEdit(row) {
      this.editMode = true;
      this.form = { id: row.id, name: row.name, identificationNumber: row.identificationNumber || '' };
      this.showForm = true;
    },
    async submitForm() {
      if (!this.form.name || !this.form.name.trim()) {
        this.$toast.danger(this.$t('userGroups.nameRequired'), { timeout: 3000 });
        return;
      }
      this.saving = true;
      const payload = {
        name: this.form.name.trim(),
        identificationNumber: this.form.identificationNumber ? this.form.identificationNumber.trim() : null,
      };
      try {
        if (this.editMode) {
          await api.put(`/UserGroup/${this.form.id}`, payload);
        } else {
          await api.post('/UserGroup', payload);
        }
        this.$toast.success(this.$t('common.saved'), { timeout: 2000 });
        this.showForm = false;
        await this.fetchGroups();
      } catch (err) {
        this.$toast.danger(err?.response?.data || this.$t('common.unableToUpdate'), { timeout: 0 });
      } finally {
        this.saving = false;
      }
    },
    async confirmDelete(row) {
      try {
        await ElMessageBox.confirm(
          this.$t('userGroups.deleteConfirm', { name: row.name }),
          this.$t('common.confirm'),
          { type: 'warning' }
        );
      } catch { return; }
      try {
        await api.delete(`/UserGroup/${row.id}`);
        this.$toast.success(this.$t('common.deleted'), { timeout: 2000 });
        await this.fetchGroups();
      } catch (err) {
        this.$toast.danger(err?.response?.data || this.$t('common.unableToDelete'), { timeout: 0 });
      }
    },
  },
};
</script>
